import {
  Box,
    Button,
  Card,
  Divider,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { FC, useEffect, useState } from "react";
import { Formik, FormikHelpers } from "formik";
import * as yup from "yup";
import "./index.css";
import jwt from "jsonwebtoken";
import { StaffUserRole } from "../../types/staffUser";
import StaffRoles from "../../helpers/UsersStaffRole";
import { getToken } from "../../helpers/getToken";
import dataProvider from "../../providers/dataProvider";
import { useDataProvider, useNotify } from "react-admin";

interface FormValuesPersonalDetails {
  firstName: string;
  lastName: string;
  email: string;
  skype: string;
}
interface FormValuesPasswords {
  oldPassword: string;
  newPassword: string;
  passwordConfirm: string;
}
const RoleOptions = [
  { id: StaffUserRole.SuperAdmin, name: "Super Administrator" },
  { id: StaffUserRole.Admin, name: "Administartor" },
  { id: StaffUserRole.Moderatore, name: "Moderator" },
];

const Profile: FC = () => {
  const [role, setRole] = useState(RoleOptions[1].id);
  const [creationDate, setCreationDate] = useState();
  const notify = useNotify();
  const [userRights, setUserRights] = useState(StaffRoles.AdministartorRights);
  const [userDetails,setUserDetails] = useState({firstName:'',lastName:'',email:'',skype:''})

  useEffect(()=>{
    getUser()
  },[])
  const getUser = async()=>{
    const token = getToken();
    const decodedToken:any = jwt.decode(token);
    await dataProvider.getOne('staffUsers', decodedToken).then((response)=>{
        setRole(response.data.role)
        setUserRights(response.data.permissions)
        setCreationDate(response.data.startDate)
        setUserDetails({
          ...userDetails,
          firstName:response.data.name || "",
          lastName:response.data.surname || "",
          email:response.data.email,
          skype:response.data.skype||""
        })
    })
  }
  const validationSchema = yup.object({
    firstName: yup
      .string()
      .min(1, "It should be more than 1 character")
      .trim()
      .matches(/^[^!@#$^%&*()"':;<>?/,|0-9]*$/, "First name  is not valid"),

    lastName: yup
      .string()
      .min(1, "It should be more than 1 character")
      .trim()
      .matches(/^[^!@#$^%&*()"':;<>?/,|0-9]*$/, "Last name is not valid"),
    email: yup
      .string()
      .email("Please enter valid email")
  });

  const validationSchemaPasswords = yup.object({
    oldPassword: yup.string().required("Please enter your old password"),
    newPassword: yup
      .string()
      .min(
        6,
        "Please enter a password. Minimum 6 characters including at least 1 number.Please note, passwords are case sensitive"
      )
      .required(
        "Please enter a password. Minimum 6 characters including at least 1 number.Please note, passwords are case sensitive"
      )
      .trim()
      .matches(
        /^[^\s]*$/,
        "Please enter a password. Minimum 6 characters including at least 1 number.Please note, passwords are case sensitive"
      )
      .matches(
        /^(?=.*\d)(?=.*[a-z])[!@#$^%&*()"':;<>?/,|0-9a-zA-Z]{6,}$/,
        "Password is invalid. Minimum 6 characters including at least 1 number.Please note, passwords are case sensitive"
      ),
    passwordConfirm: yup
      .string()
      .required("Required")
      .oneOf([yup.ref("newPassword"), ""], "Passwords must match"),
  });
  const onSubmitPersonalDetails = async (
    values: FormValuesPersonalDetails,
    actions: FormikHelpers<FormValuesPersonalDetails>
  ) => {
    try {
      const result = await dataProvider.updateUser('update/me',{
        name:values.firstName,
        surname:values.lastName,
        email:values.email,
        skype:values.skype
      })
      if (result.data) {
        notify("User successfully update", "info");
        getUser()
      }
    } catch (error) {
      notify(error.data.error, "error");
    }
    actions.setSubmitting(false);
  };

  const onSubmitChangePassword = async (
    values: FormValuesPasswords,
    actions: FormikHelpers<FormValuesPasswords>
  ) => {
    try {
      const result = await dataProvider.updateUser('update/password',{
        oldPassword:values.oldPassword,
        newPassword:values.newPassword
      })
      if (result.data) {
        notify("User successfully update", "info");
        getUser()
      }
    } catch (error) {
      notify(error.data.error, "error");
    }
    actions.setSubmitting(false);
  };
  return (
    <Box paddingTop="2rem">
      <div>
        <Typography variant="h6">Personal Details</Typography>
        <Divider />
        {userDetails.email&&<Formik
          initialValues={{
            firstName: userDetails.firstName,
            lastName: userDetails.lastName,
            email:userDetails.email,
            skype: userDetails.skype,
          }}
          validationSchema={validationSchema}
          onSubmit={onSubmitPersonalDetails}
        >
          {({
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            values,
          }) => (
            <Box marginTop="1rem" className="profileFieldsWrap">
              <Box className="profileFieldWrapper">
                <div className="inputWrapper">
                  <div className="fieldLabelWrapper rightAlign">
                    <Typography gutterBottom className="base-color">
                      First Name
                    </Typography>
                  </div>
                  <TextField
                    size="small"
                    name="firstName"
                    className="profileInputs"
                    onChange={handleChange("firstName")}
                    onBlur={handleBlur("firstName")}
                    value={values.firstName}
                    error={errors.firstName && touched.firstName ? true : false}
                    variant="outlined"
                  />
                </div>
                {errors.firstName && touched.firstName && (
                  <Box className="errorMessage">
                    <Typography color="error">{errors.firstName}</Typography>
                  </Box>
                )}
              </Box>
              <Box className="profileFieldWrapper">
                <div className="inputWrapper">
                  <div className="fieldLabelWrapper rightAlign">
                    <Typography gutterBottom className="base-color">
                      Last Name
                    </Typography>
                  </div>
                  <TextField
                    size="small"
                    name="lastName"
                    className="profileInputs"
                    onChange={handleChange("lastName")}
                    onBlur={handleBlur("lastName")}
                    value={values.lastName}
                    error={errors.lastName && touched.lastName ? true : false}
                    variant="outlined"
                  />
                </div>
                {errors.lastName && touched.lastName && (
                  <Box className="errorMessage">
                    <Typography color="error">{errors.lastName}</Typography>
                  </Box>
                )}
              </Box>
              <Box className="profileFieldWrapper">
                <div className="inputWrapper">
                  <div className="fieldLabelWrapper rightAlign">
                    <Typography className="base-color">
                      Email address
                    </Typography>
                  </div>
                  <TextField
                    size="small"
                    name="email"
                    className="profileInputs"
                    onChange={handleChange("email")}
                    onBlur={handleBlur("email")}
                    value={values.email}
                    error={errors.email && touched.email ? true : false}
                    variant="outlined"
                  />
                </div>
                {errors.email && touched.email && (
                  <Box className="errorMessage">
                    <Typography color="error">{errors.email}</Typography>
                  </Box>
                )}
              </Box>
              <Box className="profileFieldWrapper">
                <div className="inputWrapper">
                  <div className="fieldLabelWrapper rightAlign">
                    <Typography className="base-color">Skype</Typography>
                  </div>
                  <TextField
                    size="small"
                    name="skype"
                    onChange={handleChange("skype")}
                    onBlur={handleBlur("skype")}
                    value={values.skype}
                    className="profileInputs"
                    variant="outlined"
                  />
                </div>
              </Box>
              <Button onClick={handleSubmit} variant="contained" className="profileSaveBtn" type="submit" >Save changes</Button>
            </Box>
            
          )}
        </Formik>}
      </div>
      <div>
        <Typography variant="h6">Change password</Typography>
        <Divider />
        <Formik
          initialValues={{
            oldPassword: "",
            newPassword: "",
            passwordConfirm: "",
          }}
          validationSchema={validationSchemaPasswords}
          onSubmit={onSubmitChangePassword}
        >
          {({
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            values,
          }) => (
            <Box marginTop="1rem" className="profileFieldsWrap">
              <Box className="profileFieldWrapper">
                <div className="inputWrapper">
                  <div className="fieldLabelWrapper">
                    <Typography gutterBottom className="base-color">
                      Old password
                    </Typography>
                  </div>
                  <TextField
                    size="small"
                    type="password"
                    name="oldPassword"
                    className="profileInputs withCondition"
                    onChange={handleChange("oldPassword")}
                    onBlur={handleBlur("oldPassword")}
                    error={
                      errors.oldPassword && touched.oldPassword ? true : false
                    }
                    variant="outlined"
                  />
                </div>
                {errors.oldPassword && touched.oldPassword && (
                  <Box className="errorMessage">
                    <Typography color="error">{errors.oldPassword}</Typography>
                  </Box>
                )}
              </Box>
              <Box className="profileFieldWrapper">
                <div className="inputWrapper">
                  <div className="fieldLabelWrapper">
                    <Typography gutterBottom className="base-color">
                      New password
                    </Typography>
                  </div>
                  <TextField
                    size="small"
                    type="password"
                    name="newPassword"
                    className="profileInputs withCondition"
                    onChange={handleChange("newPassword")}
                    onBlur={handleBlur("newPassword")}
                    error={
                      errors.newPassword && touched.newPassword ? true : false
                    }
                    variant="outlined"
                  />
                </div>
                {errors.newPassword && touched.newPassword && (
                  <Box className="errorMessage">
                    <Typography color="error">{errors.newPassword}</Typography>
                  </Box>
                )}
              </Box>
              <Box className="profileFieldWrapper">
                <div className="inputWrapper">
                  <div className="fieldLabelWrapper">
                    <Typography gutterBottom className="base-color">
                      Confirm New password
                    </Typography>
                  </div>
                  <TextField
                    size="small"
                    type="password"
                    name="passwordConfirm"
                    className="profileInputs withCondition"
                    onChange={handleChange("passwordConfirm")}
                    onBlur={handleBlur("passwordConfirm")}
                    error={
                      errors.passwordConfirm && touched.passwordConfirm
                        ? true
                        : false
                    }
                    variant="outlined"
                  />
                </div>
                {errors.passwordConfirm && touched.passwordConfirm && (
                  <Box className="errorMessage">
                    <Typography color="error">
                      {errors.passwordConfirm}
                    </Typography>
                  </Box>
                )}
              </Box>
              <Button onClick={handleSubmit} variant="contained" className="profileSaveBtn" type="submit" >Save changes</Button>
            </Box>
          )}
        </Formik>
      </div>
      <Box>
        <Typography variant="h6">Role Details</Typography>
        <Divider variant="fullWidth" />
        <Box className="profileFieldsWrap">
          <Box marginTop="1rem" className="profileFieldWrapper">
            <div className="inputWrapper">
              <div className="fieldLabelWrapper rightAlign">
                <Typography className="base-color">Start date</Typography>
              </div>
              <Box style={{ width: 200 }}>
                <TextField
                  type="date"
                  defaultValue={
                    creationDate
                      ? creationDate
                      : new Date().toISOString().substr(0, 10)
                  }
                  disabled={true}
                  fullWidth
                  label=""
                />
              </Box>
            </div>
          </Box>
          <Box className="profileFieldWrapper">
            <div className="inputWrapper">
              <div className="fieldLabelWrapper rightAlign">
                <Typography className="base-color">Role</Typography>
              </div>
              <Box style={{ width: 200 }}>
                {role && (
                  <Select
                    label=""
                    disabled={true}
                    fullWidth
                    variant="outlined"
                    value={role}
                    className="selectInput"
                  >
                    {RoleOptions.map((i) => {
                      return <MenuItem value={i.id}>{i.name}</MenuItem>;
                    })}
                  </Select>
                )}
              </Box>
            </div>
          </Box>
          <Box width={"70%"} marginLeft="5rem">
            <TableContainer component={Card}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Pages</TableCell>
                    <TableCell scope="row" align="center">
                      View
                    </TableCell>
                    <TableCell scope="row" align="center">
                      Update
                    </TableCell>
                    <TableCell scope="row" align="center">
                      Delete
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody className="staffUserPermisionsTable">
                  {userRights &&
                    userRights.map((row, i) => {
                      return (
                        <>
                          <TableRow key={`${row.page}${i}`}>
                            <TableCell component="th" scope="row">
                              <p
                                className={
                                  row.page === "Statistic" ||
                                  row.page === "Dream home" ||
                                  row.page === "Lifestyle Prizes" ||
                                  row.page === "Fixed Odds" ||
                                  row.page === "General" ||
                                  row.page === "Winners" ||
                                  row.page === "Referrals" ||
                                  row.page === "Reports"
                                    ? "titleSubCategory"
                                    : ""
                                }
                              >
                                {row.page}
                              </p>
                            </TableCell>
                            <TableCell scope="row" align="center">
                              <input
                                type="checkbox"
                                disabled={true}
                                checked={row.rights["View"]}
                                className="input-form"
                              />
                            </TableCell>
                            <TableCell scope="row" align="center">
                              <input
                                type="checkbox"
                                disabled={true}
                                checked={row.rights["Update"]}
                                className="input-form"
                              />
                            </TableCell>
                            <TableCell scope="row" align="center">
                              <input
                                type="checkbox"
                                disabled={true}
                                checked={row.rights["Delete"]}
                                className="input-form"
                              />
                            </TableCell>
                          </TableRow>
                          {row.page === "Competitions" ||
                          row.page === "Staff management" ? (
                            <TableRow className="titleRow">
                              <TableCell>
                                {row.page === "Competitions" ? (
                                  <p>Prize management</p>
                                ) : null}
                                {row.page === "Staff management" ? (
                                  <p>Settings</p>
                                ) : null}
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                              <TableCell></TableCell>
                            </TableRow>
                          ) : null}
                        </>
                      );
                    })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Profile;
